import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { ContractConcessionComponent } from './contract-concession.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule
  ],
  declarations: [ContractConcessionComponent],
  entryComponents: [ContractConcessionComponent],
})
export class ContractConcessionModule { }
